require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./goog.object.object.js");

require("./helix.impl.props.js");

require("./helix.impl.classes.js");

require("./cljs_bean.core.js");

require("./shadow.js.shim.module$react.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("helix.core.js");
goog.provide('helix.core');

if (typeof Symbol !== 'undefined') {
  Symbol.prototype.cljs$core$IPrintWithWriter$ = cljs.core.PROTOCOL_SENTINEL;

  Symbol.prototype.cljs$core$IPrintWithWriter$_pr_writer$arity$3 = function (sym, writer, _) {
    var sym__$1 = this;
    return cljs.core._write(writer, ["\"", cljs.core.str.cljs$core$IFn$_invoke$arity$1(sym__$1.toString()), "\""].join(''));
  };
} else {}

helix.core.Fragment = shadow.js.shim.module$react.Fragment;
helix.core.Suspense = shadow.js.shim.module$react.Suspense;
helix.core.create_element = shadow.js.shim.module$react.createElement;
helix.core.create_context = shadow.js.shim.module$react.createContext;

helix.core.get_react = function helix$core$get_react() {
  return shadow.js.shim.module$react;
};
/**
 * Create a new React element from a valid React type.
 * 
 *   Example:
 *   ```
 *   ($ MyComponent
 * "child1"
 * ($ "span"
 *   {:style {:color "green"}}
 *   "child2" ))
 *   ```
 */


helix.core.$ = function helix$core$$(var_args) {
  var args__4742__auto__ = [];
  var len__4736__auto___21498 = arguments.length;
  var i__4737__auto___21499 = 0;

  while (true) {
    if (i__4737__auto___21499 < len__4736__auto___21498) {
      args__4742__auto__.push(arguments[i__4737__auto___21499]);
      var G__21500 = i__4737__auto___21499 + 1;
      i__4737__auto___21499 = G__21500;
      continue;
    } else {}

    break;
  }

  var argseq__4743__auto__ = 1 < args__4742__auto__.length ? new cljs.core.IndexedSeq(args__4742__auto__.slice(1), 0, null) : null;
  return helix.core.$.cljs$core$IFn$_invoke$arity$variadic(arguments[0], argseq__4743__auto__);
};

helix.core.$.cljs$core$IFn$_invoke$arity$variadic = function (type, args) {
  var _QMARK_p = cljs.core.first(args);

  var _QMARK_c = cljs.core.rest(args);

  var native_QMARK_ = function () {
    var or__4126__auto__ = type instanceof cljs.core.Keyword;

    if (or__4126__auto__) {
      return or__4126__auto__;
    } else {
      var or__4126__auto____$1 = typeof type === 'string';

      if (or__4126__auto____$1) {
        return or__4126__auto____$1;
      } else {
        return new cljs.core.Keyword(null, "native", "native", -613060878).cljs$core$IFn$_invoke$arity$1(cljs.core.meta(type));
      }
    }
  }();

  var type_SINGLEQUOTE_ = type instanceof cljs.core.Keyword ? cljs.core.name(type) : type;

  if (cljs.core.map_QMARK_(_QMARK_p)) {
    return cljs.core.apply.cljs$core$IFn$_invoke$arity$4(helix.core.create_element, type_SINGLEQUOTE_, cljs.core.truth_(native_QMARK_) ? helix.impl.props._dom_props.cljs$core$IFn$_invoke$arity$1(_QMARK_p) : helix.impl.props._props.cljs$core$IFn$_invoke$arity$1(_QMARK_p), _QMARK_c);
  } else {
    return cljs.core.apply.cljs$core$IFn$_invoke$arity$4(helix.core.create_element, type_SINGLEQUOTE_, null, args);
  }
};

helix.core.$.cljs$lang$maxFixedArity = 1;
/** @this {Function} */

helix.core.$.cljs$lang$applyTo = function (seq21446) {
  var G__21447 = cljs.core.first(seq21446);
  var seq21446__$1 = cljs.core.next(seq21446);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__21447, seq21446__$1);
};
/**
 * Dynamically create a new React element from a valid React type.
 * 
 *   `$` can typically be faster, because it will statically process the arguments
 *   at macro-time if possible.
 * 
 *   Example:
 *   ```
 *   ($$ MyComponent
 * "child1"
 * ($$ "span"
 *   {:style {:color "green"}}
 *   "child2" ))
 *   ```
 */


helix.core.$$ = helix.core.$;
/**
 * @interface
 */

helix.core.IExtractType = function () {};

var helix$core$IExtractType$_type$dyn_21505 = function helix$core$IExtractType$_type$dyn_21505(factory) {
  var x__4428__auto__ = factory == null ? null : factory;

  var m__4429__auto__ = helix.core._type[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(factory) : m__4429__auto__.call(null, factory);
  } else {
    var m__4426__auto__ = helix.core._type["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(factory) : m__4426__auto__.call(null, factory);
    } else {
      throw cljs.core.missing_protocol("IExtractType.-type", factory);
    }
  }
};
/**
 * Extracts the underlying type from the factory function.
 */


helix.core._type = function helix$core$_type(factory) {
  if (!(factory == null) && !(factory.helix$core$IExtractType$_type$arity$1 == null)) {
    return factory.helix$core$IExtractType$_type$arity$1(factory);
  } else {
    return helix$core$IExtractType$_type$dyn_21505(factory);
  }
};

helix.core.type = function helix$core$type(f) {
  return helix.core._type(f);
};
/**
 * Creates a factory function for a React component
 */


helix.core.factory = function helix$core$factory(type) {
  var x21464 = function () {
    var helix$core$factory_$_factory__delegate = function helix$core$factory_$_factory__delegate(args) {
      return cljs.core.apply.cljs$core$IFn$_invoke$arity$3(helix.core.$, type, args);
    };

    var helix$core$factory_$_factory = function helix$core$factory_$_factory(var_args) {
      var args = null;

      if (arguments.length > 0) {
        var G__21510__i = 0,
            G__21510__a = new Array(arguments.length - 0);

        while (G__21510__i < G__21510__a.length) {
          G__21510__a[G__21510__i] = arguments[G__21510__i + 0];
          ++G__21510__i;
        }

        args = new cljs.core.IndexedSeq(G__21510__a, 0, null);
      }

      return helix$core$factory_$_factory__delegate.call(this, args);
    };

    helix$core$factory_$_factory.cljs$lang$maxFixedArity = 0;

    helix$core$factory_$_factory.cljs$lang$applyTo = function (arglist__21511) {
      var args = cljs.core.seq(arglist__21511);
      return helix$core$factory_$_factory__delegate(args);
    };

    helix$core$factory_$_factory.cljs$core$IFn$_invoke$arity$variadic = helix$core$factory_$_factory__delegate;
    return helix$core$factory_$_factory;
  }();

  x21464.helix$core$IExtractType$ = cljs.core.PROTOCOL_SENTINEL;

  x21464.helix$core$IExtractType$_type$arity$1 = function (_) {
    var ___$1 = this;

    return type;
  };

  return x21464;
};

helix.core.cljs_factory = function helix$core$cljs_factory(type) {
  var x21469 = function () {
    var helix$core$cljs_factory_$_factory__delegate = function helix$core$cljs_factory_$_factory__delegate(args) {
      if (cljs.core.map_QMARK_(cljs.core.first(args))) {
        var props = cljs.core.first(args);
        return cljs.core.apply.cljs$core$IFn$_invoke$arity$4(shadow.js.shim.module$react.createElement, type, {
          "helix/props": cljs.core.dissoc.cljs$core$IFn$_invoke$arity$variadic(props, new cljs.core.Keyword(null, "key", "key", -1516042587), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword(null, "ref", "ref", 1289896967)], 0)),
          "key": cljs.core.get.cljs$core$IFn$_invoke$arity$3(props, new cljs.core.Keyword(null, "key", "key", -1516042587), undefined),
          "ref": cljs.core.get.cljs$core$IFn$_invoke$arity$3(props, new cljs.core.Keyword(null, "ref", "ref", 1289896967), undefined)
        }, cljs.core.rest(args));
      } else {
        return cljs.core.apply.cljs$core$IFn$_invoke$arity$4(shadow.js.shim.module$react.createElement, type, {}, args);
      }
    };

    var helix$core$cljs_factory_$_factory = function helix$core$cljs_factory_$_factory(var_args) {
      var args = null;

      if (arguments.length > 0) {
        var G__21512__i = 0,
            G__21512__a = new Array(arguments.length - 0);

        while (G__21512__i < G__21512__a.length) {
          G__21512__a[G__21512__i] = arguments[G__21512__i + 0];
          ++G__21512__i;
        }

        args = new cljs.core.IndexedSeq(G__21512__a, 0, null);
      }

      return helix$core$cljs_factory_$_factory__delegate.call(this, args);
    };

    helix$core$cljs_factory_$_factory.cljs$lang$maxFixedArity = 0;

    helix$core$cljs_factory_$_factory.cljs$lang$applyTo = function (arglist__21513) {
      var args = cljs.core.seq(arglist__21513);
      return helix$core$cljs_factory_$_factory__delegate(args);
    };

    helix$core$cljs_factory_$_factory.cljs$core$IFn$_invoke$arity$variadic = helix$core$cljs_factory_$_factory__delegate;
    return helix$core$cljs_factory_$_factory;
  }();

  x21469.helix$core$IExtractType$ = cljs.core.PROTOCOL_SENTINEL;

  x21469.helix$core$IExtractType$_type$arity$1 = function (_) {
    var ___$1 = this;

    return type;
  };

  return x21469;
};

helix.core.assoc_some = function helix$core$assoc_some(m, k, x) {
  if (!(x == null)) {
    return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m, k, x);
  } else {
    return m;
  }
};

helix.core.extract_cljs_props = function helix$core$extract_cljs_props(o) {
  if (goog.DEBUG && (cljs.core.map_QMARK_(o) || o == null)) {
    throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("Props received were a map. This probably means you're calling your component as a function.", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "props", "props", 453281727), o], null));
  } else {}

  var temp__5802__auto__ = goog.object.get(o, "helix/props");

  if (cljs.core.truth_(temp__5802__auto__)) {
    var props = temp__5802__auto__;
    return helix.core.assoc_some(props, new cljs.core.Keyword(null, "children", "children", -940561982), goog.object.get(o, "children"));
  } else {
    return cljs_bean.core.bean.cljs$core$IFn$_invoke$arity$1(o);
  }
};

helix.core.props_kvs_identical_QMARK_ = function helix$core$props_kvs_identical_QMARK_(prev, cur) {
  var prev_props = helix.core.extract_cljs_props(prev);
  var cur_props = helix.core.extract_cljs_props(cur);
  return cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(cljs.core.count(prev_props), cljs.core.count(cur_props)) && cljs.core.every_QMARK_(function (p1__21484_SHARP_) {
    return cljs.core.get.cljs$core$IFn$_invoke$arity$2(prev_props, p1__21484_SHARP_) === cljs.core.get.cljs$core$IFn$_invoke$arity$2(cur_props, p1__21484_SHARP_);
  }, cljs.core.keys(cur_props));
};
/**
 * Like React.memo, but passes props to `compare` as CLJS map-likes instead of
 *   JS objects.
 *   `compare` should return true if props are equal, and false if not.
 */


helix.core.memo = function helix$core$memo(var_args) {
  var G__21491 = arguments.length;

  switch (G__21491) {
    case 1:
      return helix.core.memo.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return helix.core.memo.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

helix.core.memo.cljs$core$IFn$_invoke$arity$1 = function (component) {
  return shadow.js.shim.module$react.memo(component, helix.core.props_kvs_identical_QMARK_);
};

helix.core.memo.cljs$core$IFn$_invoke$arity$2 = function (component, compare) {
  return shadow.js.shim.module$react.memo(component, function helix$core$memo_compare(o, o_SINGLEQUOTE_) {
    var G__21492 = helix.core.extract_cljs_props(o);
    var G__21493 = helix.core.extract_cljs_props(o_SINGLEQUOTE_);
    return compare.cljs$core$IFn$_invoke$arity$2 ? compare.cljs$core$IFn$_invoke$arity$2(G__21492, G__21493) : compare.call(null, G__21492, G__21493);
  });
};

helix.core.memo.cljs$lang$maxFixedArity = 2;

helix.core.create_component = function helix$core$create_component(spec, statics) {
  var render = spec.render;

  var render_SINGLEQUOTE_ = function render_SINGLEQUOTE_(this$) {
    var G__21494 = this$;
    var G__21495 = helix.core.extract_cljs_props(this$.props);
    var G__21496 = this$.state;
    return render.cljs$core$IFn$_invoke$arity$3 ? render.cljs$core$IFn$_invoke$arity$3(G__21494, G__21495, G__21496) : render.call(null, G__21494, G__21495, G__21496);
  };

  goog.object.set(spec, "render", render_SINGLEQUOTE_);
  return helix.impl.classes.createComponent(shadow.js.shim.module$react.Component, spec, statics);
};
/**
 * Registers a component with the React Fresh runtime.
 *   `type` is the component function, and `id` is the unique ID assigned to it
 *   (e.g. component name) for cache invalidation.
 */


helix.core.register_BANG_ = function helix$core$register_BANG_(type, id) {
  if (!(window.$$Register$$ == null)) {
    return window.$$Register$$(type, id);
  } else {
    return null;
  }
};

helix.core.signature_BANG_ = function helix$core$signature_BANG_() {
  if (!(window.$$Signature$$ == null)) {
    return window.$$Signature$$();
  } else {
    return false;
  }
};

Object.defineProperty(module.exports, "$$", {
  enumerable: false,
  get: function get() {
    return helix.core.$$;
  }
});
Object.defineProperty(module.exports, "create_context", {
  enumerable: false,
  get: function get() {
    return helix.core.create_context;
  }
});
Object.defineProperty(module.exports, "memo", {
  enumerable: false,
  get: function get() {
    return helix.core.memo;
  }
});
Object.defineProperty(module.exports, "IExtractType", {
  enumerable: false,
  get: function get() {
    return helix.core.IExtractType;
  }
});
Object.defineProperty(module.exports, "props_kvs_identical_QMARK_", {
  enumerable: false,
  get: function get() {
    return helix.core.props_kvs_identical_QMARK_;
  }
});
Object.defineProperty(module.exports, "get_react", {
  enumerable: false,
  get: function get() {
    return helix.core.get_react;
  }
});
Object.defineProperty(module.exports, "create_component", {
  enumerable: false,
  get: function get() {
    return helix.core.create_component;
  }
});
Object.defineProperty(module.exports, "Fragment", {
  enumerable: false,
  get: function get() {
    return helix.core.Fragment;
  }
});
Object.defineProperty(module.exports, "extract_cljs_props", {
  enumerable: false,
  get: function get() {
    return helix.core.extract_cljs_props;
  }
});
Object.defineProperty(module.exports, "cljs_factory", {
  enumerable: false,
  get: function get() {
    return helix.core.cljs_factory;
  }
});
Object.defineProperty(module.exports, "_type", {
  enumerable: false,
  get: function get() {
    return helix.core._type;
  }
});
Object.defineProperty(module.exports, "Suspense", {
  enumerable: false,
  get: function get() {
    return helix.core.Suspense;
  }
});
Object.defineProperty(module.exports, "signature_BANG_", {
  enumerable: false,
  get: function get() {
    return helix.core.signature_BANG_;
  }
});
Object.defineProperty(module.exports, "type", {
  enumerable: false,
  get: function get() {
    return helix.core.type;
  }
});
Object.defineProperty(module.exports, "$", {
  enumerable: false,
  get: function get() {
    return helix.core.$;
  }
});
Object.defineProperty(module.exports, "factory", {
  enumerable: false,
  get: function get() {
    return helix.core.factory;
  }
});
Object.defineProperty(module.exports, "assoc_some", {
  enumerable: false,
  get: function get() {
    return helix.core.assoc_some;
  }
});
Object.defineProperty(module.exports, "create_element", {
  enumerable: false,
  get: function get() {
    return helix.core.create_element;
  }
});
Object.defineProperty(module.exports, "register_BANG_", {
  enumerable: false,
  get: function get() {
    return helix.core.register_BANG_;
  }
});